import { TableBody, TableContainer, Table, TableHead, TableRow } from '@mui/material';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import StyledTableCell from '../../../../components/StyledTableCell';
import { Spinner } from '../../../../components/Spinner';
import { useEffect, useState } from 'react';

function DashboardRewards({
  rewardsDashboard,
  getRewardsDashboard,
  rewardsCategory,
  setRewardsCategory,
}) {
  const [spinner, setSpinner] = useState(false);

  useEffect(() => {
    (async () => {
      if (rewardsDashboard !== null) {
        setSpinner(true);
        await getRewardsDashboard();
        setSpinner(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rewardsCategory]);

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between">
        <div>Rewards</div>
        <Form.Select
          className="bo-filter"
          disabled={spinner}
          value={rewardsCategory ?? ''}
          onChange={e => setRewardsCategory(e.target.value)}
        >
          <option value="">All Categories</option>
          <option value="ARTICLE">Articles</option>
          <option value="VIDEO">Videos</option>
          <option value="SURVEY">Surveys</option>
          <option value="CHALLENGE">Challenges</option>
        </Form.Select>
      </Card.Header>
      <Card.Body className="bo-min-h-100">
        <Spinner visible={spinner} text="">
          {rewardsDashboard && (
            <TableContainer>
              <Table aria-labelledby="tableTitle" aria-label="enhanced table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left" />
                    <StyledTableCell align="center">Read/Watch</StyledTableCell>
                    <StyledTableCell align="center">Subscribed</StyledTableCell>
                    <StyledTableCell align="center">Succeeded</StyledTableCell>
                    <StyledTableCell align="center">Failed</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {[
                    ['Today', 'today'],
                    ['Yesterday', 'yesterday'],
                    ['This Week', 'thisWeek'],
                    ['This Month', 'thisMonth'],
                    ['Previous Month', 'prevMonth'],
                  ].map(([name, key]) => (
                    <TableRow key={key} hover tabIndex={-1}>
                      <StyledTableCell align="left">
                        <strong>{name}</strong>
                      </StyledTableCell>
                      <StyledTableCell align="center">{rewardsDashboard[key].READ}</StyledTableCell>
                      <StyledTableCell align="center">
                        {rewardsDashboard[key].SUBSCRIBED}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {rewardsDashboard[key].SUCCEEDED}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {rewardsDashboard[key].FAILED}
                      </StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Spinner>
      </Card.Body>
    </Card>
  );
}

export default DashboardRewards;
